import React, { SVGAttributes } from "react";

const Transfer: React.FC<SVGAttributes<any>> = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="31" viewBox="0 0 30 31" fill="none">
      <path
        d="M18.9009 28.7092C25.5707 28.7092 28.2386 26.0413 28.2386 19.3715V11.3678C28.2386 4.69805 25.5707 2.03015 18.9009 2.03015H10.8972C4.22747 2.03015 1.55957 4.69805 1.55957 11.3678V19.3715C1.55957 26.0413 4.22747 28.7092 10.8972 28.7092H18.9009Z"
        stroke="currentColor"
        stroke-opacity="0.8"
        stroke-width="2.61939"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M21.7691 17.7976L17.7139 21.8528" stroke="#FFBE40" stroke-width="2.61939" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M8.0296 17.7975H21.7693" stroke="#FFBE40" stroke-width="2.61939" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M8.0296 12.9417L12.0848 8.88651" stroke="#FFBE40" stroke-width="2.61939" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M21.7694 12.9417H8.02966" stroke="#FFBE40" stroke-width="2.61939" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
};

export default Transfer;
